import { render } from "./plansAdmin.vue?vue&type=template&id=1fab375a&scoped=true"
import script from "./plansAdmin.vue?vue&type=script&lang=js"
export * from "./plansAdmin.vue?vue&type=script&lang=js"

import "./plansAdmin.vue?vue&type=style&index=0&id=1fab375a&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fab375a"]])

export default __exports__